import { UseFormSetValue } from 'react-hook-form';

type props = {
  name: string;
  setValue: UseFormSetValue<any>;
  value: string | undefined;
  min?: number;
  max?: number;
};

export function fStringInputWithoutSpecialCharacters({ name, setValue, value }: props) {
  if (value) {
    setValue(name, value.replace(/[^\w\s]/gi, ''));
  } else {
    setValue(name, undefined);
  }
}

export function fNumberInput({ name, setValue, value }: props) {
  if (value && value.match(/[0-9.]/gi)) {
    setValue(name, Number(value.replace(/[^0-9.]/gi, '')));
  } else {
    setValue(name, undefined);
  }
}

export function fNumberInputWithCommas({ name, setValue, value }: props) {
  if (value && value.match(/[0-9.,]/gi)) {
    setValue(name, Number(value.replace(/[^0-9.,]/gi, '')));
  } else {
    setValue(name, undefined);
  }
}

export function fNumberInputMinMax({
  name,
  setValue,
  value,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
}: props) {
  if (value && Number(value.replace(/[^0-9..,]/gi, '')) < min) {
    setValue(name, min);
    return;
  }

  if (value && Number(value.replace(/[^0-9..,]/gi, '')) > max) {
    setValue(name, max);
    return;
  }

  setValue(name, value?.replace(/[^0-9.]/gi, '') ?? undefined);
}
